import React from 'react'
import '../stylesheets/Home.css';
import HomeCarousel from '../Carousel.jsx';
import {BrowserView, MobileView} from 'react-device-detect';

export const Home = () => {
  return (
    <div className= "body">
        <h2 className="subhead" id="first">Welcome</h2>
        <BrowserView>
          <p id="intro" className="patua-one-regular"> Here at Arrival Design, we are a family-owned, full-service web design and branding company with over 10 years of industry experience.</p>
        </BrowserView>
        <MobileView>
          <p id="mobileIntro" className="patua-one-regular"> Here at Arrival Design, we are a family-owned, full-service web design and branding company with over 10 years of industry experience.</p>
        </MobileView>
        <br></br>
        <h2 className="subhead">Our Work</h2>
        <HomeCarousel />
    </div>
  )
}
